import Container from "react-bootstrap/Container";
import logo from "../../../assets/images/logo.png";
import { Link } from "react-router-dom";
import { BsFacebook, BsTwitter, BsPhone } from "react-icons/bs";
import { AiFillMail , AiFillInstagram } from "react-icons/ai";
import { BiMap } from "react-icons/bi";
import "./Index.scss";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();

  const handleClickScroll = () => {
    const element = document.getElementById('products');
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="Footer_Main">
      <Container>
        <article>
          <div>
            <img src={logo} alt="logo" />
            <p>
              Herzmann is a designer, developer and manufacturer of modular
              operating theaters and laboratory furniture.
            </p>
            <ul>
              <li>
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  className="d-flex justify-content-center align-items-center"
                >
                  <BsFacebook />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  className="d-flex justify-content-center align-items-center"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  className="d-flex justify-content-center align-items-center"
                >
                  <BsTwitter />
                </a>
              </li>
            </ul>
            <span>
              Copyright &copy; 2014-{year} Herzmann. All rights reserved.
              Version 1.0.0.
            </span>
          </div>
          <div>
            <ul>
              <li>
                <Link to="/" onClick={handleClickScroll}>Operation Theater</Link>
              </li>
              <li>
                <Link to="/">Laboratory</Link>
              </li>
              <li>
                <Link  to="accessories"
                  state={{ type: "Alle" }}>Accessories</Link>
              </li>
            </ul>
          </div>
          <div>
            <h3>Contact</h3>
            <span>
              <BiMap color="white" size={"1.5em"} />
              <p>HERZMANN Medizintechnik GmbH, Pinneberger Str. 43, D-22457, Germany</p>
            </span>
            <span>
              <BsPhone color="white" size={"1.5em"} />
              <p>+1 000 000 000</p>
            </span>
            <span>
              <AiFillMail color="white" size={"1.5em"} />
              <p>bdm@herzmannmedical.de</p>
            </span>
          </div>
        </article>
      </Container>
    </footer>
  );
}

export default Footer;
